var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaselineLayout',[_c('web-map',{attrs:{"slot":"main"},slot:"main"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }